import { createStore } from "vuex";
// import createPersistedState from "vuex-persistedstate";
import applicant from "./modules/applicant";
import occupation from "./modules/occupation";
import family from "./modules/family";
import colleague from "./modules/colleague";
import upload from "./modules/upload";

// initial state
// let initialState = {
//   applicant: applicant.state,
//   occupation: occupation.state,
//   family: family.state,
//   colleague: colleague.state,
//   upload: upload.state,
// };
const freshState = () => ({
  applicant: applicant.state(),
  occupation: occupation.state(),
  family: family.state(),
  colleague: colleague.state(),
  upload: upload.state(),
});

const store = createStore({
  modules: {
    applicant,
    occupation,
    family,
    colleague,
    upload,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {
    reset(state) {
      // Object.keys(initialState).forEach((key) => {
      //   state[key] = initialState[key];
      // });
      const fresh = freshState();
      Object.keys(fresh).forEach((key) => {
        state[key] = fresh[key];
      });
    },
  },
  plugins: [// createPersistedState()
],
});

export default store;
